import * as React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import type { Reservation } from '@/api';
import type { Toll } from '@/api';
import TollCard from '@/components/toll-card';
import { Text } from '@/ui';

export interface TollsProps {
  reservation: Reservation;
}

export default function Tolls({ reservation }: TollsProps) {
  const { styles, theme } = useStyles(stylesheet);
  const showProcessingFee = !reservation.passThroughTolls;

  return (
    <View style={styles.container}>
      {reservation?.tolls.map((toll: Toll) => (
        <TollCard
          toll={toll}
          key={toll.id}
          costType="customer"
          showAdminFee={showProcessingFee}
        />
      ))}

      {reservation?.tolls.length === 0 ? (
        <View
          style={{
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Text
            type="bodyRegular"
            style={{ color: theme.colors.text.secondary }}
          >
            You don't have any tolls
          </Text>
        </View>
      ) : null}
    </View>
  );
}

const stylesheet = createStyleSheet((_theme) => ({
  container: {
    flexGrow: 1,
    flexDirection: 'column',
    borderRadius: 24,
    gap: 16,
    paddingBottom: 48,
  },
}));
